import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_ROLES_ACTION_TYPE } from '../actions';

const initialState = [];

const loanRolesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_ROLES_ACTION_TYPE.GET_LOAN_ROLES:
        return payload;

      case LOAN_ROLES_ACTION_TYPE.CREATE_LOAN_ROLE_ASSIGNMENT:
        draft.push(payload);
        break;

      case LOAN_ROLES_ACTION_TYPE.EDIT_LOAN_ROLE_ASSIGNMENT: {
        const index = draft.findIndex(({ loanRoleId }) => loanRoleId === payload.loanRoleId);
        const isLoanRoleExist = index !== -1;

        if (isLoanRoleExist) {
          draft[index] = payload;
        }

        break;
      }

      case LOAN_ROLES_ACTION_TYPE.DELETE_LOAN_ROLE_ASSIGNMENT:
        return draft.filter(({ loanRoleId }) => loanRoleId !== payload.loanRoleId);

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanRolesReducer;
